export const extractYoutubeData = (url) => {
    if (!url) return { videoId: null, startAt: null, endAt: null };

    // Normalize
    url = url.trim().replace(/<|>/g, "");

    // Extract videoId
    const idRegex = /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/))([A-Za-z0-9_-]{11})/;
    const idMatch = url.match(idRegex);

    const videoId = idMatch ? idMatch[1] : null;

    // Parse query+fragment parameters
    const query = url.split("?")[1] || "";
    const fragment = url.split("#")[1] || "";

    const params = new URLSearchParams(query);
    const hashParams = new URLSearchParams(fragment.replace(/^t=/, "t="));

    // Helper to convert YouTube times (1h2m3s, 90s, 90)
    const parseTime = (value) => {
        if (!value) return null;

        // If pure number → seconds
        if (/^\d+$/.test(value)) return Number(value);

        // Parse 1h2m3s
        const match = value.match(/(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?/);
        if (!match) return null;

        const hours = Number(match[1] || 0);
        const mins  = Number(match[2] || 0);
        const secs  = Number(match[3] || 0);

        return hours * 3600 + mins * 60 + secs;
    };

    // YouTube start params: t, start
    const startParam = params.get("t") || params.get("start") || hashParams.get("t");
    const startAt = parseTime(startParam);

    // YouTube end param: end
    const endParam = params.get("end") || hashParams.get("end");
    const endAt = parseTime(endParam);

    return { videoId, startAt, endAt };
};


export const fetchYoutubeMetadata = async videoId => {
    const url = `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`;

    const response = await fetch(url);
    if (!response.ok) throw new Error("Video not found");

    return await response.json(); // title, author_name, thumbnail_url
};